/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import { IBetTypeShowTypeWithBets } from 'src/app/models/bet/betsAndBetTypeShowTypeWithOnlineStatus.interface';
import { IBetTypeGroup } from 'src/app/models/betType/betTypeGroup.interface';
import { IBetTypeShowType } from 'src/app/models/betType/betTypeShowType.interface';
import { EventType, SBVDisplayType, SBVSelectionType, BetTypeNameDisplayType, BetTypeOutcomeShowType, BetOutcomeResult, HomeAway } from 'src/app/models/enums';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { EventsService } from 'src/app/services/events.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UtilityService } from 'src/app/services/util/utility.service';
declare let $: any;
@Component({
  selector: 'app-results-event-details',
  templateUrl: './results-event-details.component.html',
  styleUrls: ['./results-event-details.component.less']
})
export class ResultsEventDetailsComponent implements OnInit, AfterViewInit, OnChanges {
  public betTypeGroups: IBetTypeGroup[] = [];
  public selectedBetTypeGroup: IBetTypeGroup = null;
  public filteredBetsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets };
  public betsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets };
  public eventTypeENUM = EventType;

  // @Input()
  // showEventDetail: boolean;
  public SBVDisplayTypeEnum = SBVDisplayType;
  public SBVSelectionEnum = SBVSelectionType;
  public betTypeNameDispayTypeEnum = BetTypeNameDisplayType;
  public betTypeOutcomeShowTypeEnum = BetTypeOutcomeShowType;
  public outcomeResultStatusEnum = BetOutcomeResult;

  protected isMobileView: boolean;
  protected isLive = false;

  private scrollHeight = 0;

  @Input()
  expandedEventResult: IEventResult;


  viewConfigurations = ViewConfigurations;
  enumsHomeAway = HomeAway;

  constructor(
    private eventsService: EventsService,
    private utilityService: UtilityService,
    private settingsService: SettingsService,
    private loaderService: LoaderService) {

  }

  ngOnInit(): void {
    this.isMobileView = this.utilityService.mobileView;
  }


  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if ($('.bet-menu-wrap').length > 0 && this.isMobileView) {
        $('.bet-menu-wrap').animate({ scrollLeft: 100 }, 600);
        setTimeout(() => {
          $('.bet-menu-wrap').animate({ scrollLeft: 0 }, 600);
        }, 600);
        clearInterval(interval);
      }
    }, 100);
    if (this.isMobileView) {
      window.addEventListener('scroll', this.scroll, true); // third parameter
    }
  }

  ngOnChanges(): void {
    this.settingsService.getBetTypeShowTypes().subscribe((btst) => {
      this.getBetsAndGroupsForEvent(btst);
    });
  }

  hideDetails() {
    this.eventsService.expandEventResult(this.expandedEventResult);

  }

  getBetsAndGroupsForEvent(betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }) {
    this.loaderService.showHideLoader(true);
    this.selectedBetTypeGroup = null;
    this.filteredBetsAndBetTypeShowType = null;
    let betsCount = 0;
    this.betsAndBetTypeShowType = {};

    this.eventsService.getResultedBetsAndGroups(this.expandedEventResult).subscribe(betsAndGroups => {
      this.betTypeGroups = betsAndGroups.groups;
      betsAndGroups.bets.forEach((bet) => {
        if (this.viewConfigurations.hideResultOutcomesIfNoOdd) {
          bet.betOutcomes = bet.betOutcomes?.filter(bo => !!bo.odd || bo.resultStatus === BetOutcomeResult.Passed);
          const ids = Object.keys(bet.betOutcomesDic);
          for (const id of ids) {
            bet.betOutcomesDic[id] = bet.betOutcomesDic[id]?.filter(bo => !!bo.odd || bo.resultStatus === BetOutcomeResult.Passed);
            if (bet.betOutcomesDic[id].length < 1) {
              delete bet.betOutcomesDic[id];
            }
          }
          if (bet.betOutcomes.length === 0) {
            return;
          }
        }
        if (!this.betsAndBetTypeShowType[bet.betTypeId]) {
          const betTypeShowTypeWithBets: IBetTypeShowTypeWithBets =
          {
            betTypeShowType: null,
            bets: [],
            betsDictionary: {},
            isAnyBetPlayable: false,
            mostBalancedBetIndex: -1,
            isExpanded: true,
            betTypeOutrightName: '',
          };

          if (!betTypeShowTypes[bet.betTypeId]) {
            console.log('No betTypeShowType for betTypeId: ' + bet.betTypeId);
            return;
          }
          betTypeShowTypeWithBets.betTypeShowType = betTypeShowTypes[bet.betTypeId];
          this.betsAndBetTypeShowType[bet.betTypeId] = betTypeShowTypeWithBets;

        }

        bet.betOutcomes.forEach(bto => {
          bto.name = this.utilityService.getBetOutcomeNameFromBTO(bto, this.betsAndBetTypeShowType[bet.betTypeId].betTypeShowType, this.expandedEventResult.homeTeam, this.expandedEventResult.awayTeam, this.expandedEventResult.eventType);
        });

        betsCount++;
        this.betsAndBetTypeShowType[bet.betTypeId].isAnyBetPlayable = true;

        this.betsAndBetTypeShowType[bet.betTypeId].bets.push(bet);
        if (this.expandedEventResult.eventType === EventType.Outright) {
          this.betsAndBetTypeShowType[bet.betTypeId].betTypeOutrightName = bet.outrightName;
        }
        this.betsAndBetTypeShowType[bet.betTypeId].betsDictionary[bet.id] = bet;
      });
      this.checkIfBetsAndOutcomesArePlayableForAllBetTypes();
      this.eventsService.setOnlineForBetTypeGroups(this.betTypeGroups, this.betsAndBetTypeShowType);
      this.selectGroup(this.betTypeGroups.find((gr) => gr.isOnline));
      this.loaderService.showHideLoader(false);
    });
  }

  toggleDescription(event) {
    event.currentTarget.nextElementSibling.classList.toggle('hover');
  }
  showDescription(event) {
    document.querySelectorAll('.description-title').forEach(e => e.classList.remove('show'));
    const desc = event.currentTarget.nextElementSibling;
    if (desc) {
      desc.classList.toggle('show');
      const width = window.outerWidth - event.x - 15;
      if (this.isMobileView) {
        desc.style.maxWidth = width + 'px';

      }
    }
  }

  showTitle(event){

    if (event.currentTarget.children.length === 1) {
      const newSpan = document.createElement('span');
      newSpan.className = 'description-title show';
      newSpan.innerText = event.currentTarget.attributes.title.value;
      const width = window.outerWidth - event.x - 15;

      if (this.isMobileView) {
        newSpan.style.maxWidth = width + 'px';

      }
      document.querySelectorAll('.description-title').forEach(e => e.remove());
      event.currentTarget.append(newSpan);

    } else {
      document.querySelectorAll('.description-title').forEach(e => e.remove());
    }

  }

  selectGroup(group: IBetTypeGroup) {
    if (group && !group.isSelected) {
      if (this.selectedBetTypeGroup) {
        this.selectedBetTypeGroup.isSelected = false;
      }
      group.isSelected = true;
      this.selectedBetTypeGroup = group;
      this.eventsService.setOnlineForBetTypeGroups(this.betTypeGroups, this.betsAndBetTypeShowType);
      this.filteredBetsAndBetTypeShowType = this.eventsService.getBetsAndBetTypeShowTypeForBetTypeGroup(group, this.betsAndBetTypeShowType);
    }
  }

  checkIfBetsAndOutcomesArePlayableForAllBetTypes() {
    const betTypeIds = Object.keys(this.betsAndBetTypeShowType);
    for (const betTypeId of betTypeIds) {
      this.eventsService.setIsAnyBetPlayableForBetTypeShowTypeWithBets(this.betsAndBetTypeShowType[+betTypeId], true);
    }
  }

  scroll = (event): void => {
    const move = 2;

    if (event.target.id === 'contentWrap' && document.getElementById('expandEventWrap')) {
      if (document.getElementById('streaminWidgetWrap')) {
        const sww = document.getElementById('streaminWidgetWrap');
        const sportIds = [1, 2, 3, 4]; // Soccer, Basketball, Ice Hockey, Tennis

        const sportId = Number(document.getElementById('expandEventWrap').dataset.sportid);

        if (event.target.scrollTop < move) {
          this.scrollHeight = event.target.scrollHeight;
        }

        if (event.target.scrollTop > move && this.scrollHeight - event.target.offsetHeight > 300 && sportIds.includes(sportId)) {
          sww.classList.add('scroll');

        } else {
          sww.classList.remove('scroll');
        }

      }

    }
    // tslint:disable-next-line: semicolon
  };
}
